module.exports = __webpack_public_path__ + "img/screen3.8748ca20.png";